import React from 'react';
import { Trans } from 'react-i18next';
import styled from 'styled-components';
import { SERVICE_GROUP_ID } from '@/constants';
type Props = {
  serviceGroupId: number;
};

export const BillingContactHint: React.FC<Props> = ({ serviceGroupId }) => {
  let hintLink = '';
  if (serviceGroupId === SERVICE_GROUP_ID.emba) {
    hintLink = 'https://globis4biz.zendesk.com/hc/ja/articles/8828139311513';
  } else if (serviceGroupId === SERVICE_GROUP_ID.hodaiplus) {
    hintLink = 'https://globis4biz.zendesk.com/hc/ja/articles/21962548280089';
  } else {
    hintLink = 'https://globis4biz.zendesk.com/hc/ja/articles/900003047886';
  }

  let scheduleLink = '';
  if (serviceGroupId === SERVICE_GROUP_ID.emba) {
    scheduleLink =
      'https://globis4biz.zendesk.com/hc/ja/articles/8828091540761';
  } else if (serviceGroupId === SERVICE_GROUP_ID.hodaiplus) {
    scheduleLink =
      'https://globis4biz.zendesk.com/hc/ja/articles/21962280688921';
  } else {
    scheduleLink = 'https://globis4biz.zendesk.com/hc/ja/articles/360000454821';
  }

  return (
    <StyledDiv>
      <Trans i18nKey="text.subscription.billingContactHintAboutCombinedInvoice">
        <a href={scheduleLink} rel="noopener noreferrer" target="_blank">
          link
        </a>
        <a href={hintLink} rel="noopener noreferrer" target="_blank">
          link
        </a>
      </Trans>
    </StyledDiv>
  );
};

const StyledDiv = styled.div`
  color: #5281ff;
  display: inline;
  a {
    text-decoration: underline;
  }
`;
